/* eslint-disable import/prefer-default-export */

export enum AppErrorSeverity {
  NORMAL = 'NORMAL',
  HIGH = 'HIGH',
  CRITICAL = 'CRITICAL',
}
